(() => {
  'use strict';
  if (window.llAssuranceReady) return;
  window.llAssuranceReady = true;

  let active = null;
  let frame = 0;
  const margin = 16;
  const gap = 10;

  const close = (restoreFocus = false) => {
    if (!active) return;
    const { trigger, panel } = active;
    active = null;
    if (typeof panel.hidePopover === 'function' && panel.matches(':popover-open')) panel.hidePopover();
    panel.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    if (restoreFocus && trigger.isConnected) trigger.focus({ preventScroll: true });
  };

  const position = () => {
    frame = 0;
    if (!active) return;
    const { trigger, panel } = active;
    if (!trigger.isConnected) { close(); return; }
    const rect = trigger.getBoundingClientRect();
    const viewport = window.visualViewport;
    const left = viewport ? viewport.offsetLeft : 0;
    const top = viewport ? viewport.offsetTop : 0;
    const width = viewport ? viewport.width : document.documentElement.clientWidth;
    const height = viewport ? viewport.height : window.innerHeight;
    const right = left + width;
    const bottom = top + height;
    if (rect.bottom <= top || rect.top >= bottom || rect.right <= left || rect.left >= right) {
      close();
      return;
    }

    panel.style.width = `${Math.min(340, width - margin * 2)}px`;
    panel.style.maxHeight = `${height - margin * 2}px`;
    const naturalHeight = panel.getBoundingClientRect().height;
    const above = Math.max(0, rect.top - top - margin - gap);
    const below = Math.max(0, bottom - rect.bottom - margin - gap);
    const placeAbove = above >= naturalHeight || above >= below;
    const availableHeight = placeAbove ? above : below;
    // Keep the summary next to the chip; long content scrolls within the panel.
    panel.style.maxHeight = `${Math.max(1, availableHeight)}px`;
    const bounds = panel.getBoundingClientRect();
    const x = Math.min(Math.max(rect.left + rect.width / 2 - bounds.width / 2, left + margin), right - margin - bounds.width);
    const y = placeAbove ? rect.top - gap - bounds.height : rect.bottom + gap;
    panel.style.left = `${Math.round(x)}px`;
    panel.style.top = `${Math.round(Math.max(top + margin, y))}px`;
    panel.dataset.placement = placeAbove ? 'above' : 'below';
  };

  const schedulePosition = () => {
    if (active && !frame) frame = requestAnimationFrame(position);
  };

  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-assurance-trigger]');
    if (trigger) {
      const panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!panel) return;
      if (active && active.trigger === trigger) { close(); return; }
      close();
      active = { trigger, panel };
      trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      // The top layer avoids clipping by the product layout. Older browsers use fixed positioning.
      if (typeof panel.showPopover === 'function') panel.showPopover();
      position();
      return;
    }
    if (!active) return;
    if (event.target.closest('[data-assurance-close]')) { close(true); return; }
    if (!active.panel.contains(event.target)) close();
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || !active) return;
    event.preventDefault();
    close(true);
  });

  document.addEventListener('focusin', event => {
    if (active && event.target !== active.trigger && !active.panel.contains(event.target)) close();
  });

  window.addEventListener('scroll', schedulePosition, { passive: true, capture: true });
  window.addEventListener('resize', schedulePosition, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('scroll', schedulePosition, { passive: true });
    window.visualViewport.addEventListener('resize', schedulePosition, { passive: true });
  }
})();
